import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { login_path, default_path, privacy_info } from '../navigation/path';
import { RootState } from '../../db/redux/store';

const onboarding_paths = [login_path, privacy_info];

function RequireAuth({
  children,
  replace,
}: {
  children?: JSX.Element | null;
  replace?: string;
}): any {
  const location = useLocation();
  const path = location.pathname;

  const { authStatus } = useAuthenticator((ctx) => [ctx.authStatus]);
  const isAuthed = authStatus === 'authenticated';

  const { has_accepted_terms } = useSelector((state: RootState) => state.auth);
  const termsKnown = has_accepted_terms !== null;

  console.log('[GUARD]', {
    path,
    authStatus,
    isAuthed,
    has_accepted_terms,
    termsKnown
  });

  // 1) While Amplify is resolving auth, show loader
  if (authStatus !== 'authenticated' && authStatus !== 'unauthenticated') {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  // 2) If authenticated BUT terms not yet known, DO NOT redirect
  if (isAuthed && !termsKnown) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  // 3) If authenticated and terms NOT accepted -> force privacy
  if (isAuthed && has_accepted_terms === false && path !== privacy_info) {
    return <Navigate to={privacy_info} replace />;
  }

  // 4) If authenticated and on onboarding path, only redirect when terms accepted
  if (
    isAuthed &&
    has_accepted_terms === true &&
    onboarding_paths.includes(path) &&
    path !== default_path
  ) {
    return <Navigate to={default_path} replace />;
  }

  // 5) If not authenticated and trying to access protected routes -> login
  if (!isAuthed && !onboarding_paths.includes(path) && path !== login_path) {
    return <Navigate to={login_path} replace state={{ from: location }} />;
  }

  // Optional explicit replace redirect
  if (replace && path !== replace) {
    return <Navigate to={replace} replace />;
  }

  return children ?? <div />;
}

export default RequireAuth;
